import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_INICIALITZAR_METEORS,
        AVIS_INTRODUCCIO_OBTENIR_METEORS } from '../../actions/actionTypes';

const ESTAT_INICIAL = {};

const meteors = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case AVIS_INTRODUCCIO_OBTENIR_METEORS:
            return action.meteors;

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_INICIALITZAR_METEORS:
            return ESTAT_INICIAL;

        default:
            return state;
    }
};

export default meteors;



// WEBPACK FOOTER //
// ./src/reducers/avis/meteors.js